<form [formGroup]="googleAddressForm">
    <div class="google-autocomplete-wrapper">
        <label for="googleStreetAddress" class="sr-only">Enter street address</label>
        <div class="autocomplete-input-container" [class.has-value]="fc.googleAddressLoc.value">
            <i class="fa fa-map-marker autocomplete-icon" aria-hidden="true"></i>
            <input type="text" id="googleStreetAddress" class="form-control autocomplete-input" (keydown.enter)="$event.preventDefault()"
                placeholder="Enter your street address" aria-label="Enter your street address" formControlName="googleAddressLoc" autocorrect="off"
                autocapitalize="off" spellcheck="off" autocomplete="street-address" (keyup)="validateLocation()" #searchLocation>
            <button type="button" class="autocomplete-clear-btn" *ngIf="fc.googleAddressLoc.value" (click)="clearAddress()" aria-label="Clear address input">
                <i class="fa fa-times" aria-hidden="true"></i>
            </button>
        </div>
    </div>
    <span *ngIf="showError" role="alert" aria-live="polite" style="color: rgb(164, 9, 9);">Please enter a valid address</span>
</form>